import { render } from "./UsefulCard.vue?vue&type=template&id=23abd16f"
import script from "./UsefulCard.vue?vue&type=script&lang=js"
export * from "./UsefulCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__